import { i18n } from 'i18n';

export const ROUTE_PATH = '/accounts';
export const TITLE = i18n._('Accounts');
